import { cart } from '../Cart/Cart';

export class ThankYouPage {
  /**
     * Removes the item from the cart in the local storage on the thankyou pages
     */
  constructor(path = window.location.pathname) {
    if (!path) {
      return;
    }

    const thankyouPages = [
      'bedankpagina-aanmelding-examentraining',
      'bedankpagina-aanvraag-codelab',
      'summary',
    ];

    const parts = path.split('/').filter(part => part !== '');
    const lastItem = parts[parts.length - 1];

    if (thankyouPages.includes(lastItem)) {
      cart.empty();
    }
  }
}
